<template>
  <div>
    <iq-card v-if="company">
      <template v-slot:headerTitle>
        <h4 class="">
          {{ $t("user-college.users") }}
        </h4>
      </template>
      <template v-slot:headerAction>
        <b-button
          class="mr-1 float-right"
          @click="$refs.modalFormUser.show()"
          variant="primary"
          >{{ $t("companies.add-user") }}</b-button
        >
      </template>
      <template v-slot:body>
        <b-col md="12" class="table-responsive">
          <b-table
            class="table mb-0 table-borderless"
            :items="company.users"
            :fields="columns"
            :busy="
              !Array.isArray(company.users) || company.users.length === 0
                ? true
                : false || isBusy == true
            "
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <div v-if="isBusy">
                  <b-spinner type="grow" class="align-middle"></b-spinner>
                  <strong> Cargando datos...</strong>
                </div>
                <span class="h5" v-else>{{ $t("app.not-found") }}</span>
              </div>
            </template>

            <template v-slot:cell(action)="data">
              <b-button
                variant=" iq-bg-danger rounded"
                size="sm"
                @click="deleteItem(data.item.id)"
                ><i class="ri-delete-bin-line ml-1"></i
              ></b-button>
            </template>
          </b-table>
        </b-col>
      </template>
    </iq-card>
    <modal-form-user ref="modalFormUser" />
  </div>
</template>
<script>
import { core } from "@/config/pluginInit";
import modalFormUser from "./addUser.vue";
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
export default {
  name: "CompanyUsers",
  components: {
    modalFormUser,
  },
  methods: {
    ...mapActions({
      fetchCompany: "fetchCompany",
      deleteCompanyUser: "deleteCompanyUser",
    }),
    deleteItem(id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("app.body-confirm-delete"), {
          title: this.$t("app.title-confirm-delete"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "success rounded",
          cancelVariant: "outline-danger rounded",
          okTitle: this.$t("app.yes"),
          cancelTitle: this.$t("app.not"),
          headerClass: "text-center",
          bodyClass: "text-center text-danger",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            const resp = await this.deleteCompanyUser({
              user_id: id,
              company_id: this.$route.params.id,
            });
            if (resp?.status == 200) {
              core.showSnackbar("success", resp.data.message);
            }
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
  data() {
    return {
      isBusy: false,
    };
  },
  computed: {
    ...mapGetters({
      company: "company",
      companiesLoading: "companiesLoading",
    }),
    columns() {
      return [
        {
          label: this.$t("profile.firstName"),
          key: "name",
          class: "text-left",
        },
        {
          label: this.$t("profile.lastName"),
          key: "first_lastname",
          class: "text-left",
          formatter: (lastname) => (lastname ? lastname : "Sin definir"),
        },
        { label: this.$t("profile.email"), key: "email", class: "text-left" },
        { label: this.$t("app.action"), key: "action", class: "text-center" },
      ];
    },
  },
};
</script>
<style>
.content-width {
  max-width: 460px !important;
}
</style>
